import React from 'react';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';

import css from './OrderBreakdown.module.css';

const { Money } = sdkTypes;

/**
 * Provider-only. When the success-fee tax is charged inclusively, the CT sales
 * tax is already inside the fee (it is not a separate deduction). This shows the
 * seller how much of the fee is that tax, using the exact figure Stripe returned
 * (persisted to `protectedData.commissionSalesTaxIncluded`, in subunits) so the
 * display matches the calculation and remittance end to end.
 *
 * @component
 * @param {Object} props
 * @param {propTypes.transaction} props.transaction - For the persisted figure + currency.
 * @param {boolean} props.isProvider
 * @param {string} props.currency - Marketplace currency fallback.
 * @param {intlShape} props.intl
 * @returns {JSX.Element|null}
 */
const LineItemCommissionTaxIncludedMaybe = props => {
  const { transaction, isProvider, currency, intl } = props;
  if (!isProvider) return null;

  const includedSubunits = transaction?.attributes?.protectedData?.commissionSalesTaxIncluded;
  if (!(includedSubunits > 0)) return null;

  const taxCurrency = transaction?.attributes?.payinTotal?.currency || currency;

  return (
    <div className={css.feeInfo}>
      <FormattedMessage
        id="OrderBreakdown.commissionTaxIncluded"
        values={{ tax: formatMoney(intl, new Money(includedSubunits, taxCurrency)) }}
      />
    </div>
  );
};

export default LineItemCommissionTaxIncludedMaybe;
